import { Link } from 'react-router-dom';

const EepromTools = () => {
  return (
    <div className="eeprom-tools">
      <h2>EEPROM Tools</h2>
      <p>
        Upload an EEPROM file and choose your modification options. This area
        will support multiple file types and processing workflows.
      </p>
      <div className="section-card">
        <img
          className="eeprom-image"
          src="/images/EEPROM.jpg"
          alt="EEPROM chip close-up"
        />
      </div>
      <section className="eeprom-list">
        <h3>Supported Modules</h3>
        <div className="eeprom-cards">
          <Link className="eeprom-card" to="/eeprom/f430-cluster">
            <h4>Ferrari 360/F430 Instrument Cluster</h4>
            <p>Read/modify EEPROM settings for 360 and F430 cluster modules.</p>
            <span>Open</span>
          </Link>
          <Link className="eeprom-card" to="/eeprom/f430-airbag">
            <h4>Ferrari F430 Airbag ECU</h4>
            <p>Erase crash data stored on the F430 airbag ECU.</p>
            <span>Open</span>
          </Link>
          <div className="eeprom-card eeprom-card-disabled">
            <h4>More modules coming soon</h4>
            <p>Additional Ferrari and DIY modules will be added here.</p>
            <span>Coming soon</span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EepromTools;
